import { Infoboard } from '../../components/Infoboard';

export const Field = () => {
  return (
    <section className='field'>
      <Infoboard />
    </section>
  );
};
